import Environment from '../../Environment';
import MockSplit from '../../MockSplit';
import stages from '../stages';

/**
 * MD-136: selects the support-widget provider.
 * When ON  ('on'), the app initializes Gleap and routes the support
 *           launchers to GleapButton / LegacyGleapButton.
 * When OFF ('control'), the existing Intercom path runs unchanged.
 *
 * The split is attribute-independent — staged rollout is per-environment.
 * Rollback is deployment-based (mock splits are code-shipped): restore the
 * stage's treatment to 'control' and redeploy.
 *
 * v2: lower environments (LOCAL, DEV, STAGING) are ON by default so Gleap
 * serves all customer regions in non-prod for testing/validation; DEMO and
 * PRODUCTION remain Intercom ('control'). Narrow or flip PRODUCTION later by
 * editing the lists below.
 *
 * v3 (MD-136 hotfix): DEV flipped to Intercom ('control') so the fixed
 * async-chunk Intercom path is validated in dev before any provider change
 * reaches production. STAGING stays Gleap ('on') for Gleap validation.
 */
const controlEnv = (name) =>
    new Environment({
        name,
        evaluationFn: () => 'control',
    });

const onEnv = (name) =>
    new Environment({
        name,
        evaluationFn: () => 'on',
    });

const local = onEnv(stages.LOCAL);
const dev = controlEnv(stages.DEV);
const staging = onEnv(stages.STAGING);
const demo = controlEnv(stages.DEMO);
const prod = controlEnv(stages.PRODUCTION);

const use_gleap_support_widget = new MockSplit({
    name: 'use_gleap_support_widget',
    environments: [local, dev, staging, demo, prod],
});

export default use_gleap_support_widget;
